export default __webpack_public_path__ + "static/media/pic7.47d7fa43.jpg";